'use client';
import { Fieldset } from './fieldset.js';
import { FieldsetDescription } from './fieldset-description.js';
import { FieldsetLegend } from './fieldset-legend.js';

/**
 * Fieldset component, used to wrap a form field.
 *
 * @example
 * <Fieldset>
 *   <Fieldset.Legend>Skriv inn dine svar</Fieldset.Legend>
 *   <Fieldset.Description>
 *     Gi en kort beskrivelse i begge feltene
 *   </Fieldset.Description>
 *   <Field>
 *     <Label>Kort beskrivelse</Label>
 *     <Input />
 *   </Field>
 * </Fieldset>
 */
const FieldsetComponent = Object.assign(Fieldset, {
    Legend: FieldsetLegend,
    Description: FieldsetDescription,
});
FieldsetComponent.Legend.displayName = 'Fieldset.Legend';
FieldsetComponent.Description.displayName = 'Fieldset.Description';

export { FieldsetComponent as Fieldset, FieldsetDescription, FieldsetLegend };
